import { GlobeLock, ChevronRight } from "lucide-react";

const ditNavigation = [
    {
        key: "/dit/endpointRules",
        icon: <GlobeLock className="icon" />,
        label: "Endpoint Rules",
        navigate: "/dit/endpointRules",
        expandIcon: ({ isOpen }) => (
            <ChevronRight
                className={`icon transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
            />
        ),
        children: [
            { key: "/dit/endpointRules/requests", label: "Requests", navigate: "/dit/endpointRules/requests", },
            { key: "/dit/endpointRules/policies", label: "Policies", navigate: "/dit/endpointRules/policies", },
            { key: "/dit/endpointRules/logs", label: "Authentication Logs", navigate: "/dit/endpointRules/logs", }
        ]
    }
];


export default ditNavigation;